// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__31r5g","options":"AnswerScale_options__19Bdm","selected":"AnswerScale_selected__3pMCY"};